<template>
  <footer class="footer">
    <div class="footer-content">
      <p>&copy; SQL Query Formatter -
        <a href="https://chromewebstore.google.com/detail/sql-query-formatter/bidjaiocipfpfkdkfkcijnglmcdmoeac" target="_blank" rel="noopener noreferrer">
          Browser Extension
        </a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  width: 100%;
  background-color: #f8f9fa;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  position: fixed;
  bottom: 0;
  left: 0;
}

.footer-content {
  width: 100%;
  max-width: 1200px; /* или другое значение, соответствующее макету вашего сайта */
  padding: 0 20px;
  text-align: center;
}

.footer p {
  margin: 0;
}

.footer a {
  color: #9A33CC;
  text-decoration: none;
}

.footer a:hover {
  text-decoration: underline;
}
</style>